import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 18a1 1 0 0 1 -1 1h-11l6 -7m-3 -7h8a1 1 0 0 1 1 1v2","key":"svg-0"}],["path",{"d":"M3 3l18 18","key":"svg-1"}]]

/**
 * IconSumOff
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc3VtLW9mZiIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTggMThhMSAxIDAgMCAxIC0xIDFoLTExbDYgLTdtLTMgLTdoOGExIDEgMCAwIDEgMSAxdjIiIC8+CiAgPHBhdGggZD0iTTMgM2wxOCAxOCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/sum-off
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconSumOff = createReactComponent('outline', 'sum-off', 'SumOff', __iconNode);

export default IconSumOff;